import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LogoManager = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const response = await axios.get('/api/logo');
      if (response.data.logo_url) {
        setLogoUrl(response.data.logo_url);
        setPreview(response.data.logo_url && response.data.logo_url.startsWith('http') ? response.data.logo_url : response.data.logo_url || '');
      }
    } catch (error) {
      console.error('Error fetching logo:', error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      // Preview oluştur
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!logoFile && !logoUrl) {
      alert('Lütfen bir logo dosyası seçin veya logo URL girin');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();
      
      if (logoFile) {
        formDataToSend.append('logo', logoFile);
      } else if (logoUrl) {
        formDataToSend.append('logo_url', logoUrl);
      }

      await axios.put('/api/logo', formDataToSend, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      alert('Logo başarıyla güncellendi!');
      fetchLogo();
      setLogoFile(null);
    } catch (error) {
      console.error('Error updating logo:', error);
      alert('Logo güncellenirken hata oluştu: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async () => {
    if (!window.confirm('Logoyu kaldırmak istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      formData.append('logo_url', '');
      
      await axios.put('/api/logo', formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      alert('Logo kaldırıldı');
      setLogoUrl(null);
      setPreview(null);
      setLogoFile(null);
      fetchLogo();
    } catch (error) {
      console.error('Error removing logo:', error);
      alert('Logo kaldırılırken hata oluştu');
    }
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <h2 className="text-2xl font-bold text-gold mb-6">Logo Yönetimi</h2>

      <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg space-y-6">
        {/* Preview */}
        {preview && (
          <div className="flex flex-col items-center gap-4 p-6 bg-navy-800 rounded-lg border border-gold/20">
            <h3 className="text-white font-semibold">Mevcut Logo Önizleme</h3>
            <div className="bg-white/10 p-4 rounded-lg">
              <img
                src={preview}
                alt="Logo preview"
                className="max-h-32 max-w-full object-contain"
                onError={() => setPreview(null)}
              />
            </div>
            <p className="text-white/60 text-sm text-center">
              Bu logo header'da görünecektir
            </p>
          </div>
        )}

        {/* File Input */}
        <div>
          <label className="block text-white mb-2">
            Logo Dosyası (PNG önerilir) *
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            required={!logoUrl}
          />
          <p className="text-white/60 text-xs mt-1">
            Şeffaf arka planlı PNG dosyası önerilir. Maksimum boyut: 5MB
          </p>
        </div>

        {/* URL Input (Alternative) */}
        <div>
          <label className="block text-white mb-2">
            Veya Logo URL
          </label>
          <input
            type="url"
            value={logoUrl || ''}
            onChange={(e) => {
              setLogoUrl(e.target.value);
              if (e.target.value) {
                setPreview(e.target.value);
              }
            }}
            className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            placeholder="https://example.com/logo.png"
          />
          <p className="text-white/60 text-xs mt-1">
            Harici bir URL'den logo yüklemek için
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            type="submit"
            disabled={loading || (!logoFile && !logoUrl)}
            className="flex-1 bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Kaydediliyor...' : 'Logoyu Güncelle'}
          </button>
          
          {preview && (
            <button
              type="button"
              onClick={handleRemove}
              className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
            >
              Logoyu Kaldır
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default LogoManager;
